<template>
  <div id="app">
   <heads></heads>
    <router-view/>
    <footers></footers>
  </div>
</template>
<script>
import heads from './components/head.vue'
import footers from './components/footer.vue'
export default {
components:{
heads,
footers
}
}
</script>
<style>
#app{
  background-color: #FFFFFF;
}


</style>
